import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

export function useWorkerBlockBookingFeatureFlag(): boolean {
  return useCbhFlag(CbhFeatureFlag.WORKER_BLOCK_BOOKING, {
    defaultValue: false,
  });
}
